<div class="top-panel-box">
    <app-breadcrumb
        [breadcrumbs]="
            topPanelConfiguration.breadcrumbs && topPanelConfiguration.breadcrumbs.length > 0
                ? topPanelConfiguration.breadcrumbs
                : undefined
        "
        [pageMainTitle]="topPanelConfiguration.pageMainTitle"
    ></app-breadcrumb>
    <div class="spacer"></div>
    <div class="filter-container">
        @if (topPanelConfiguration.buttonConfiguration && topPanelConfiguration.buttonConfiguration.length > 0) {
            @for (button of topPanelConfiguration.buttonConfiguration; track button) {
                <button
                    mat-flat-button
                    color="primary"
                    type="button"
                    class="download-btn"
                    [disabled]="button.isButtonDisable"
                    (click)="onBtnClick.emit(button.buttonActionEmitEvent)"
                >
                    {{ button.buttonName }}
                </button>
            }
        }
    </div>
</div>
